import { mapGetters } from 'vuex';
import Controls from '@/components/controls/Controls.vue';

export default {
  name: 'Result',
  components: {
    Controls
  },
  computed: {
    ...mapGetters([
      'currentGame',
      'resultInSec',
      'openedFrom'
    ])
  }
};
